import React, { Component } from 'react';
import { Menu, Container, Button } from 'semantic-ui-react';
import { withFirebase } from 'react-redux-firebase'
import 'semantic-ui-css/semantic.min.css';

import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import SignedOutMenu from './Menus/SignedOutMenu';
import SignedInMenu from './Menus/SignedInMenu';
import { openModal } from '../modals/modalActions';

const actions = {
    openModal
}
const mapState = (state) => ({
    auth: state.firebase.auth,
    profile: state.firebase.profile
})

class NavBar extends Component {

    handleSignIn = () => {
        this.props.openModal('LoginModal')
    };

    handleRegister = () => {
        this.props.openModal('RegisterModal')
    }

    handleSignOut = () => {
        this.props.firebase.logout();
        this.props.history.push('/')
    };
    render() {
        const { auth, profile } = this.props;
        const authenticated = auth.isLoaded && !auth.isEmpty

        return (
            <Menu inverted fixed="top">
                <Container>
                    <Menu.Item as={Link} to="/" header>
                        Word by Word
                    </Menu.Item>

                    <Menu.Item>
                        <Button basic inverted>
                            <a href="mailto:allenplai@gmail.com">Contact Us</a>
                        </Button>
                    </Menu.Item>

                    {authenticated ? (
                        <SignedInMenu profile={profile} signOut={this.handleSignOut} />
                    ) : (
                            <SignedOutMenu register={this.handleRegister} signIn={this.handleSignIn} />
                        )}
                </Container>
            </Menu>
        );
    }
}

export default withRouter(withFirebase(connect(mapState, actions)(NavBar)));



// WEBPACK FOOTER //
// ./src/Components/nav/NavBar.jsx